export function cubeVolCalc(l, b, h, units) {
    console.log("Unit: " + units)
    !l ? (l = 0) : null;
    !b ? (b = 0) : null;
    !h ? (h = 0) : null;
    let volume = l * b * h;
    let volWater = volumeToWaterVol(volume, units);
    let unit = unitName(units)
    return volWater + " " + unit
}

export function cylVolCalc(r, h, u){
    !r ? (r = 0) : null;
    !h ? (h = 0) : null;
    let volume = ( Math.PI * r ** 2 ) * h
    let volWater = volumeToWaterVol(volume, u)
    let unit = unitName(u)
    return volWater + " " + unit
}

// Returns a unit name depending on whether metric or impercial are being used
function unitName(units){
    let unitName;
    if (units === "metric") {
        unitName = "litres"
    } else if (units     === "imperial") {
        unitName = "gallons"
    } else {
        unitName = ""
    }
    return unitName
}

// Returns a volume of water based on cubic metres or feet
function volumeToWaterVol(vol, units){
    let volWater;
    units === "imperial" ? volWater = vol * 7.48052 : volWater = vol / 0.001
    return roundUp(volWater, 0)
}

function roundUp( num, precision ) {
    return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
}

// Filters a number for negative and turns it into a positive
export function filterNeg(inputNumber){
    if ( inputNumber < 0 ) return Math.abs(inputNumber);
    // if ( inputNumber < 0 ) return console.log("Filter Neg!")
    else return inputNumber
}